import React__default from 'react';
export { color } from '@stacks/ui-utils';
import { getPersistedColorMode } from './utils.esm.js';
export { THEME_STORAGE_KEY, colorGet, documentColorLoaderSting, generateCssVariables, getInvertedValue, getPersistedColorMode, handleSetColorMode, initColorMode, setDocumentStyles } from './utils.esm.js';
import { useColorModeState, useColorModeEffect } from './hooks.esm.js';
import { ColorModeContext } from './context.esm.js';
export { BaseStyles, ColorModes, DarkMode, LightMode } from './styles.esm.js';

var ColorModeProvider = function ColorModeProvider(_ref) {
  var defaultMode = _ref.defaultMode,
      children = _ref.children;
  var local = getPersistedColorMode();
  var state = useColorModeState(local || defaultMode);
  useColorModeEffect(defaultMode);
  return /* @__PURE__ */React__default.createElement(ColorModeContext.Provider, {
    value: state
  }, children);
};

export { ColorModeProvider };
//# sourceMappingURL=index.esm.js.map
